import { render, staticRenderFns } from "./BArquivoFilterBar.vue?vue&type=template&id=818aee70"
import script from "./BArquivoFilterBar.vue?vue&type=script&lang=js"
export * from "./BArquivoFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports